
export default {
  name: 'AppNaverIcon',
  props: {
    iconSize: { type: Number, default: 36 }
  }
};
